import { isEqual } from 'lodash';

import BaseDropdown from './dropdown';

class DateRangesDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'dateRanges';
    // List item can be targeted by the range name, e.g. $('.dropdown-items.sevenDay')
    this.identifierField = 'name';
    this.dropdownDiv = null;
    this.hasSearch = false;

    this.state = {
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
      dateRanges: this.props.items,
      graphType: this.props.graphType || '',
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.items, this.props.items) ||
      !isEqual(prevProps.graphType, this.props.graphType)
    ) {
      this.setState({
        label: this.getLabel(this.props.items),
        graphType: this.props.graphType,
      });
    }
  }

  select(index, event) {
    const updatedItems = this.props.items.map((option, idx) => {
      return { ...option, selected: idx === index };
    });

    const selectedOption = updatedItems.find(option => option.selected);
    const gaLabel = `${this.props.gaEvent.label} ${selectedOption.label}`;
    this.AnalyticService.trackEvent(this.props.gaEvent.category, 'Execute', gaLabel);

    this.setState({
      dateRanges: updatedItems,
      label: this.getLabel(updatedItems),
    });
    this.props.updateRange(updatedItems);
  }
}

export default DateRangesDropdown;
